module.exports = "images/doc-program-menu.16a1de09a13cc035ebc20189b0b3687a.png";